// url + link helpers

export function isExternalUrl(href, siteHost) {
  if (!href) return false;
  try {
    const u = new URL(href, 'http://internal.local');
    const isHttp = u.protocol === 'http:' || u.protocol === 'https:';
    return isHttp && siteHost && u.host !== siteHost;
  } catch {
    return false;
  }
}

export function externalLinkProps(href, siteHost = process.env.NEXT_PUBLIC_SITE_DOMAIN) {
  return isExternalUrl(href, siteHost) ? { target: '_blank', rel: 'noopener noreferrer' } : {};
}
